/**

 * Autenticação e checkout — re-exporta requests/responses de `@imobdesk/contracts`.

 */

import { auth } from '@imobdesk/contracts'



export const loginRequestSchema = auth.loginRequestSchema

export type LoginRequest = auth.LoginRequest



export const loginSuccessResponseSchema = auth.loginSuccessResponseSchema

export type LoginSuccessResponse = auth.LoginSuccessResponse



export const refreshTokenResponseSchema = auth.refreshTokenResponseSchema

export type RefreshTokenResponse = auth.RefreshTokenResponse



export const contratarRequestSchema = auth.contratarRequestSchema

export type ContratarRequest = auth.ContratarRequest



export const contratarPreviewSchema = auth.contratarPreviewSchema

export type ContratarPreview = auth.ContratarPreview



export const contratarCheckoutResponseSchema = auth.contratarCheckoutResponseSchema

export type ContratarCheckoutResponse = auth.ContratarCheckoutResponse



export const contratarPreviewResponseSchema = auth.contratarPreviewResponseSchema

export type ContratarPreviewResponse = auth.ContratarPreviewResponse



export const checkoutSuccessResponseSchema = auth.checkoutSuccessResponseSchema

export type CheckoutSuccessResponse = auth.CheckoutSuccessResponse



export const checkoutTargetTokenRequestSchema = auth.checkoutTargetTokenRequestSchema

export const checkoutTargetTokenResolveSchema = auth.checkoutTargetTokenResolveSchema

export const checkoutTargetTokenGenerateResponseSchema =

  auth.checkoutTargetTokenGenerateResponseSchema

export const checkoutTargetTokenResolveResponseSchema =

  auth.checkoutTargetTokenResolveResponseSchema



/**

 * Validação do PIN de 6 dígitos no fluxo guest de `/contratar`.

 * O código validado vai em `contratarRequestSchema.otpCode` no checkout público —

 * não usa `POST /auth/check-magic-link` (diferente do app `login`).

 */

export const validateOtpFormSchema = auth.validateOtpRequestSchema

export type ValidateOtpForm = auth.ValidateOtpRequest


